import * as React from "react";

import { Input } from "@neworbit/simpleui-input";
import { ThunkDispatch } from "redux-thunk";
import { Action } from "redux";
import { connect } from "react-redux";

import { TaskCategory } from "../../taskCategories/model";
import { ApplicationState } from "../../applicationState";

import { loadTaskCategories } from "../../taskCategories";

interface StateProps {
    taskCategories: TaskCategory[];
}

interface DispatchProps {
    loadTaskCategories: () => void;
}

interface OwnProps {
    selectedTaskCategories: string[];
    onSelectionChanged: (selection: string[]) => void;
}

type Props = StateProps & DispatchProps & OwnProps;

const TaskCategoryDropdownUnconnected: React.FunctionComponent<Props> = (props) => {
    React.useEffect(() => {
        if (props.taskCategories.length === 0) {
            props.loadTaskCategories();
        }
    }, []);

    return (
        <Input.DropdownMulti
            dynamicOptions
            value={props.selectedTaskCategories}
            label="Task Categories"
            onChange={props.onSelectionChanged}
            options={props.taskCategories.map(taskCategory =>
                ({ key: taskCategory.name, value: taskCategory.name, text: taskCategory.name }))}
            search
        />
    );
};

const mapStateToProps = (state: ApplicationState): StateProps => ({
    taskCategories: state.taskCategories
});

const mapDispatchToProps = (dispatch: ThunkDispatch<ApplicationState, undefined, Action>): DispatchProps => ({
    loadTaskCategories: () => dispatch(loadTaskCategories())
});

export const TaskCategoryDropdown = connect(mapStateToProps, mapDispatchToProps)(TaskCategoryDropdownUnconnected);
